module Elma.Bindings {

    interface ICreateUser {
        link?: string,
        type?: string
    }

    export class CreateUser {
        private postUser(element: any, valueAccessor: () => ICreateUser, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            var FtwData = new Ftw.Data;
            var FtwLogger = Ftw.Base.Config.Logger;

            if (!bindingContext) {
                return;
            }

            var value = ko.unwrap(valueAccessor());
            value = typeof value == "undefined" ? {} : value; // make standard settings
            var creationType = typeof value.type == "undefined" ? "regular" : value.type;
            var userLink = typeof value.link == "undefined" ? "/Handlers/Firstweb.ERP.Users.ashx?cmd=createcustomer" : value.link; // make standard value for post


            $(element).on('submit', function (e: Event) {
                e.stopImmediatePropagation(); // prevent double submission 
                e.preventDefault();
                var currentForm = $(this);
                var data = $(this).serialize();
                if (creationType == "login") {
                    bindingContext.$data.newUserLoader(true);
                }
                FtwData.postForm(userLink, data).then(function (json: IFirstWebERPService) {
                    var status = json.ERPStatus;
                    if (status) {
                        if (status.Success == false) {
                            FtwLogger.error(status.Code);
                            FtwLogger.error(status.Message);
                            currentForm.find(".js-error-message").removeClass("hide");
                            currentForm.find(".js-error-text").text(status.Message);
                        }
                        else {
                            currentForm.find(".js-form-group").addClass("hide");
                            currentForm.find(".js-error-message").hide();
                            currentForm.find(".js-success-message").removeClass("hide");
                            currentForm.find("#btnSave").hide();

                        }
                    }

                    if (creationType == "login") {
                        if (json.ERPStatus.Code != 0) {
                            currentForm.find('.status').removeClass('show');
                            currentForm.find('.error-' + json.ERPStatus.Code).addClass('show');
                        } else {
                            currentForm.find('.status').removeClass('show');
                            bindingContext.$data.successOrFail(true);
                        }

                        bindingContext.$data.newUserLoader(false);

                    }

                });

            });
        }

        public init = this.postUser;
        public update = this.postUser;
    }

    ko.bindingHandlers['createUser'] = new CreateUser();



}